<template>
    <VJoyHighlight>
        <VJoyWrapper direction="row" justify="flex-start" align="center" :no-margin="true">
            <VJoyIcon name="eye-masked" color="secondary" />
            <VJoyText>
                <template v-if="hiddenByClient">
                    {{
                        t('profile.hidden.appraisals.by.client.count', {
                            count: hiddenCounter,
                        })
                    }}
                </template>
                <template v-else>
                    {{
                        t('profile.hidden.appraisals.count', {
                            accountFirstName: accountFirstname,
                            nbrHiddenAppraisals: hiddenCounter,
                        })
                    }}
                </template>
            </VJoyText>
        </VJoyWrapper>
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyHighlight, VJoyIcon, VJoyText, VJoyWrapper} from '@maltjoy/core-vue';

    type Props = {
        accountFirstname?: string;
        hiddenCounter: number;
        hiddenByClient: boolean;
    };
    defineProps<Props>();
    const {t} = useTranslation();
</script>
